import { z } from '../params'

// The invocation the runtime hands to the polling SYSTEM method on each tick. Runtime-owned, not
// author-declared. LOOSE: the flow engine may send fields a given milestone doesn't model yet.
export const PollingInvocationSchema = z.looseObject({
  eventName: z.string().min(1),
  // The trigger instance's configured params — validated against the trigger's own schema separately.
  triggerData: z.record(z.string(), z.unknown()).optional(),
  state: z.record(z.string(), z.unknown()).nullish(),
  learningMode: z.boolean().optional(),
  connectionId: z.string().nullish(),
})
